import { render } from "./DashboardModule.vue?vue&type=template&id=1495cdc4&scoped=true"
import script from "./DashboardModule.vue?vue&type=script&lang=js"
export * from "./DashboardModule.vue?vue&type=script&lang=js"

import "./DashboardModule.vue?vue&type=style&index=0&id=1495cdc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1495cdc4"]])

export default __exports__